import * as React from 'reactn';
import {
    base,
    BaseColor,
    IBaseProps, ComponentFactory, LocalCache
} from "oca-lib-web";

import Sidebar from "../component/Sidebar";
import SocialUtil from "../util/SocialUtil";
import Constants from "../util/Constants";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
}

class SendNotificationPage extends React.Component<IBaseProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        this.state = {
            componentFactory: componentFactory,
        };
    }

    async componentWillMount() {
        console.log(this.props);
        // @ts-ignore
        const urlParams = this.props.location.search;
        const queryString = require('query-string');
        const parsed = queryString.parse(urlParams);
        const code = parsed.code;
        const accessToken = SocialUtil.getLinkedInAccessToken(code);
        LocalCache.saveLocal(Constants.CACHE_LINKEDIN_ACCESS_TOKEN, accessToken);
    }

    public render() {
        const cf = this.state.componentFactory;

        return (
            cf.renderBoxProps({fullHeight:true, background:BaseColor.MAIN_BACKGROUND}, [
                cf.renderBoxProps({center:true, marginTop:60}, "Thank you! Your LinkedIn account is now connected")
            ])
        )
    }
}

export default base(SendNotificationPage, Sidebar)